<template>
  <section :style="{height:'100%'}" class="geomagnetic-historical-detail">
    <div class="go-back" @click="goback" >返回></div>
    <div class="table-list">
      <el-table
      v-loading="loading"
        ref="table"
        border
        :data="tableListData"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        
      >
      <el-table-column
          show-overflow-tooltip
          label="地磁类型"
          prop="type"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="地磁编号"
          prop="devSn"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="信号上报时间"
          prop="lastUpTime"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="服务器时间"
          prop="crtTime"
          width="150px"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="事件"
          prop="content"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="电量"
          prop="pow"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="信号强度"
          prop="network"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="信噪比"
          prop="snr"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="温度"
          prop="temp"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="版本"
          prop="nbVer"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="地磁状态"
       
        >
      <template slot-scope="scope">
       <span :style="{display:'inline-block',width:'100%',height:'100%',backgroundColor:scope.row.nbStatus&&scope.row.nbStatus!=0?'yellow':''}">{{scope.row.nbStatus}}</span> 
      </template>
      
      </el-table-column>
    </el-table>
    </div>
   
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </section>
</template>
<script>
import { mapMutations } from "vuex";
import {alarmLogHistory} from "@/api/url.js"
import Page from "../../../commons/page.vue";
export default{
  data(){
    return{
      tableListData:[],
      devSn:'',
      search: {
        pageNumber: 1,
        pageSize: 10,
      
      },
      
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      styleObj: {
        "text-align": "center",
      },
      pageObj: {},
      loading:false,
    }

  },
  components: {
    Page,
    
  },
  created(){
    
    this.devSn=this.$route.query.devSn;
  },
  mounted(){
this.tableList(1);
  },
  methods:{
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    goback(){
      this.$router.go(-1)
    },
    tableList(curPage) {
      var _this = this;
      this.loading=true;
      this.$get(alarmLogHistory(), {
        limit: this.search.pageSize,
        page: curPage,
        devSn: this.devSn,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
       
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // _this.getPage(pageObj);
        this.pageObj={...pageObj}
        _this.tableListData = data.data.rows;
      }).finally(()=>{
        this.loading=false;
      });
    },

  }
}
</script>
<style scoped> 
.go-back {
  padding: 20px 10px;
  cursor: pointer;
}
.table-list{
  height:calc(100vh - 200px);
}
</style>
<style>


</style>